<footer class="Footer" data-test-id="portalFooter">
  <div class="container">
    @for (row of rows; track row) {
      <section
        class="Footer__Row"
        data-test-id="portalFooterRow"
        [ngStyle]="{ 'margin-bottom': row.marginBottom }"
      >
        @for (column of row.columns; track column) {
          <div class="Footer__Column" data-test-id="portalFooterColumn">
            @for (line of column; track line) {
              @switch (line?.type) {
                @case (types.address) {
                  <div
                    class="Footer__Line--Address"
                    data-test-id="portalFooterAddress"
                  >
                    <p tabindex="0" class="Footer__Link">
                      {{ line.line1 }}
                    </p>
                    <p tabindex="0" class="Footer__Link">
                      {{ line.line2 }}
                    </p>
                  </div>
                }
                @case (types.title) {
                  <div class="Footer__Line" data-test-id="portalFooterText">
                    <p
                      tabindex="0"
                      class="Footer__Title"
                      [innerHTML]="line.label"
                    ></p>
                  </div>
                }
                @case (types.header) {
                  <div
                    class="Footer__Line--Header"
                    data-test-id="portalFooterHeader"
                  >
                    <h5
                      tabindex="0"
                      class="Footer__Header"
                      [ngClass]="{
                        'Footer__Header--Center': line.textAlignCenter,
                      }"
                    >
                      {{ line.label }}
                    </h5>
                  </div>
                }
                @case (types.icon) {
                  <icon
                    data-test-id="portalFooterIcon"
                    [name]="line.icon"
                    [config]="{
                      size: 'large',
                      type: 'link',
                      fill: 'pf-icon',
                    }"
                  >
                  </icon>
                }
                @case (types.image) {
                  @if (line.route) {
                    <a
                      tabindex="0"
                      class="Footer__Line--Image"
                      [attr.href]="line.route"
                      [target]="line.target ? line.target : '_blank'"
                      data-test-id="portalFooterImage"
                    >
                      <img
                        [attr.title]="line.title"
                        [alt]="line.title"
                        [src]="line.source"
                        [ngStyle]="{
                          width: line.width,
                          height: line.height,
                        }"
                      />
                    </a>
                  } @else {
                    <img
                      class="Footer__Line--Image"
                      [attr.title]="line.title"
                      [alt]="line.title"
                      [src]="line.source"
                      [ngStyle]="{
                        width: line.width,
                        height: line.height,
                      }"
                    />
                  }
                }
                @case (types.link) {
                  <div class="Footer__Line" data-test-id="portalFooterLink">
                    <ds-link
                      [linkConfig]="getLinkConfig(line)"
                      [externalSiteModalConfig]="externalSiteModalConfig"
                      [dataNavEvent]="line.route | getEventRoute"
                    >
                      <div class="Footer__Link" tabindex="0">
                        <p class="Footer__Link--Label">
                          {{ line.label }}
                        </p>
                        @if (line.isExternalRoute && line.showIcon) {
                          <icon [name]="line.icon || 'open_in_new'"></icon>
                        }
                      </div>
                    </ds-link>
                  </div>
                }
                @case (types.longText) {
                  <div
                    class="Footer__Line--Paragraphs"
                    data-test-id="portalFooterLongText"
                  >
                    @for (paragraph of line.paragraphs; track paragraph) {
                      <p
                        tabindex="0"
                        class="Footer__Text"
                        [ngClass]="{
                          'Footer__Header--Center': line.textAlignCenter,
                        }"
                      >
                        {{ paragraph }}
                      </p>
                    }
                  </div>
                }
                @case (types.modalLink) {
                  @if (line.modal) {
                    <div
                      class="Footer__Line"
                      data-test-id="portalFooterModalLink"
                    >
                      <a
                        [dataNavEvent]="line.route | getEventRoute"
                        tabindex="0"
                        class="Footer__Link"
                        (click)="line.modal.isOpen = true"
                        (keydown.enter)="line.modal.isOpen = true"
                      >
                        {{ line.label }}
                      </a>
                    </div>
                    <modal
                      [condition]="line.modal.isOpen"
                      [config]="line.modal"
                      (cancel)="line.modal.isOpen = false"
                      (keydown.enter)="line.modal.isOpen = false"
                    >
                      <section body class="Footer__Modal--Body">
                        <div tabindex="0" [innerHtml]="line.modal.body"></div>
                      </section>
                      @if (line.modal?.footer?.link) {
                        <ng-container footer>
                          <div class="u-flex u-justifyBetween u-maxX">
                            <zip-button
                              [config]="{
                                level: 'low',
                                content: line.modal.footer.cancel || 'Cancel',
                              }"
                              (zipButtonClicked)="line.modal.isOpen = false"
                            >
                            </zip-button>
                            <zip-button
                              [config]="{
                                level: 'high',
                                content: line.modal.footer.proceed || 'Proceed',
                              }"
                              (zipButtonClicked)="goTo(line.modal.footer?.link)"
                            >
                            </zip-button>
                          </div>
                        </ng-container>
                      }
                    </modal>
                  }
                }
                @case (types.phone) {
                  <div class="Footer__Line" data-test-id="portalFooterPhone">
                    <p
                      tabindex="0"
                      class="Footer__Text"
                      [ngClass]="{
                        'Footer__Header--Center': line.textAlignCenter,
                      }"
                    >
                      {{ line.label }}
                      <a
                        [dataNavEvent]="line.phone | getEventRoute"
                        class="Footer__Link--Phone"
                        [attr.href]="'tel:' + line.phone"
                        >{{ line.phone }}</a
                      >
                    </p>
                  </div>
                }
                @case (types.text) {
                  <div class="Footer__Line" data-test-id="portalFooterText">
                    <p
                      tabindex="0"
                      class="Footer__Text"
                      [ngClass]="{
                        'Footer__Header--Center': line.textAlignCenter,
                      }"
                      [innerHTML]="line.label"
                    ></p>
                  </div>
                }
              }
            }
          </div>
        }
      </section>
    }
  </div>
</footer>
